module.exports = __webpack_public_path__ + "img/icon-university.2d0ff565.svg";